/* import __COLOCATED_TEMPLATE__ from './save-or-cancel.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    onCancel?: () => void;
    onSave?: () => void;
    savingDisabled?: boolean;
    disabledTooltipContent?: string;
    section: string;
  };
}

const SaveOrCancel = templateOnlyComponent<Signature>();
export default SaveOrCancel;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinVoice::Editor::SaveOrCancel': typeof SaveOrCancel;
    'workflows/graph-editor/node-items/steps/fin-voice/editor/save-or-cancel': typeof SaveOrCancel;
  }
}
